import { Tabs } from 'antd';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)<{ $height: string }>`
  height: ${(props) => props.$height};

  .ant-tabs-nav {
    margin-bottom: 0;
    border-bottom: 1px solid #e5e5e5;
  }

  .ant-tabs-content-holder {
    height: ${(props) => props.$height};

    .ant-tabs-content {
      height: ${(props) => props.$height};

      .ant-tabs-tabpane {
        height: ${(props) => props.$height};
      }
    }
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0 0 0 20px;
  }
`;

export const MetricChartsWrapper = styled.div<{ horizontal: boolean }>`
  width: auto;
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  padding: 5px 0;
  padding-right: 10px;
  overflow: ${(props) => (props.horizontal ? 'unset' : 'hidden scroll')};
`;

export const WidgetsPanelWrapper = styled.div`
  border: 2px dashed #e0e1e3;
  padding: 6px;
  margin-top: 20px;

  h3 {
    color: #9f9f9f;
  }
`;

export const TabWrapper = styled.div`
  margin: 10px 0 4px;
  display: flex;
`;

export const BetaTag = styled.div`
  position: absolute;
  top: -5px;
  right: 5px;
  font-size: 8px;
`;
